export default {
    userId(state) {
      return state.userId;
    },
    token(state) {
      return state.token;
    },
    isAuthenticated(state) {
      console.group("isAuthenticated");
      console.log("isAuthenticated = ", !!state.token);
      console.groupEnd();
      return !!state.token;

    },
    didAutoLogout(state) {
      return state.didAutoLogout;
    }
};